import React, { Fragment } from "react";
import { Button } from "semantic-ui-react";
import Rodal from "rodal";
import QurealForm from "./QurealForm";
// import QPortal from "../commons/QPortal";
import { QPortal } from "./junction";

function QPopupForm({
    id,
    record_id,
    title,
    field_overwrites,
    trigger,
    wrapper_style,
    configs,
    org,
    creation_id,
}) {
    const [show, setShow] = React.useState(false);

    return (
        <Fragment>
            {trigger ? (
                <div onClick={() => setShow(true)}>{trigger}</div>
            ) : (
                <Button onClick={() => setShow(true)}>Create New</Button>
            )}
            <QPortal>
                <Rodal
                    visible={show}
                    onClose={() => setShow(false)}
                    customStyles={{
                        height: "auto",
                        bottom: "auto",
                        top: "50%",
                        transform: "translateY(-50%)",
                        borderRadius: "12px",
                        maxHeight: "95vh",
                        overflow: "auto",
                    }}
                    width={600}
                >
                    <div
                        style={{
                            margin: "1em",
                            marginTop: ".5em",
                        }}
                    >
                        <h4>{title}</h4>
                        {show && (
                            <QurealForm
                                id={id}
                                record_id={record_id}
                                onSuccess={() => setShow(false)}
                                field_overwrites={field_overwrites}
                                wrapper_style={wrapper_style}
                                configs={configs}
                                org={org}
                                creation_id={creation_id}
                            />
                        )}
                    </div>
                </Rodal>
            </QPortal>
        </Fragment>
    );
}

export default QPopupForm;
